

<template>
    <clockForm :id="id"></clockForm>
</template>

<script>
import clockForm from './form'
export default {
    components: {
        clockForm
    },
    data() {
        return {
            id: null
        }
    },
    mounted() {
        const { id } = this.$route.params
        this.id = id
    },
}
</script>